/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../../utils/logger';
import TaskFactory from '../task';
import SplitChangesUpdater from '../updater/SplitChanges';
import MySegmentsUpdater from '../updater/MySegments';
import onSplitsArrivedFactory from './onSplitsArrivedFactory';
var log = logFactory('splitio-producer:updater');
/**
 * Startup all the background jobs required for a Browser SDK instance.
 */

var FullBrowserProducer = function FullBrowserProducer(context) {
  var settings = context.get(context.constants.SETTINGS);
  var _context$get = context.get(context.constants.READINESS),
    splitsEventEmitter = _context$get.splits;
  var splitsUpdater = SplitChangesUpdater(context);
  var mySegmentsUpdater = MySegmentsUpdater(context);
  var splitsUpdaterTask = TaskFactory(synchronizeSplits, settings.scheduler.featuresRefreshRate);
  var mySegmentsUpdaterTask = TaskFactory(synchronizeMySegments, settings.scheduler.segmentsRefreshRate);
  var onSplitsArrived = onSplitsArrivedFactory(mySegmentsUpdaterTask, context);
  var _isSynchronizingSplits = false;
  var _isSynchronizingMySegments = false;
  function synchronizeSplits() {
    _isSynchronizingSplits = true;
    return splitsUpdater()["finally"](function () {
      _isSynchronizingSplits = false;
    });
  }
  /**
   * @param {string[] | undefined} segmentList might be undefined
   */

  function synchronizeMySegments(segmentList) {
    _isSynchronizingMySegments = true;
    return mySegmentsUpdater(0, segmentList)["finally"](function () {
      _isSynchronizingMySegments = false;
    });
  }
  return {
    // Start periodic fetching (polling)
    start: function start() {
      log.info('Starting BROWSER producer');
      splitsUpdaterTask.start();
      mySegmentsUpdaterTask.start();
      splitsEventEmitter.on(splitsEventEmitter.SDK_SPLITS_ARRIVED, onSplitsArrived);
    },
    // Stop periodic fetching (polling)
    stop: function stop() {
      log.info('Stopping BROWSER producer');
      splitsUpdaterTask.stop();
      mySegmentsUpdaterTask && mySegmentsUpdaterTask.stop();
      splitsEventEmitter.removeListener(splitsEventEmitter.SDK_SPLITS_ARRIVED, onSplitsArrived);
    },
    // Used by SyncManager to know if running in polling mode.
    isRunning: splitsUpdaterTask.isRunning,
    // Used by SplitUpdateWorker
    isSynchronizingSplits: function isSynchronizingSplits() {
      return _isSynchronizingSplits;
    },
    synchronizeSplits: synchronizeSplits,
    // Used by MySegmentUpdateWorker
    isSynchronizingMySegments: function isSynchronizingMySegments() {
      return _isSynchronizingMySegments;
    },
    synchronizeMySegments: synchronizeMySegments
  };
};
export default FullBrowserProducer;